import type { Ref } from 'react';

// eslint-disable-next-line no-restricted-imports
import type { ButtonBaseProps as MuiButtonBaseProps } from '@mui/material/ButtonBase';
// eslint-disable-next-line no-restricted-imports
import MuiButtonBase from '@mui/material/ButtonBase';

export type ButtonBaseProps = MuiButtonBaseProps;

export const ButtonBase = ({
  ref,
  ...props
}: ButtonBaseProps & { ref?: Ref<HTMLButtonElement> }) => {
  return (
    <MuiButtonBase
      ref={ref}
      {...props}
    />
  );
};

ButtonBase.displayName = 'ButtonBase';

export default ButtonBase;
